/**
 * description 多媒体图片
 * created by he.zhikai
 * created on 2017-12-18
 */
'use strict';
angular.module('resCenPictureModule', ['initPictureDataModule', 'resCenPictureLeftModule'])
    .controller('resCenPictureCtrl', ['$scope', '$timeout', '$q', '$window', '$stateParams', '$state', '$filter', 'trsHttpService', 'globleParamsSet', 'trsPrintService', 'modalDialog', 'resourceCenterService', 'trsspliceString', 'initPictureDataService', 'storageListenerService',
        function($scope, $timeout, $q, $window, $stateParams, $state, $filter, trsHttpService, globleParamsSet, trsPrintService, modalDialog, resourceCenterService, trsspliceString, initPictureDataService, storageListenerService) {
            initStatus();
            initData();

            /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
            function initStatus() {
                $scope.page = { // 分页信息
                    CURRPAGE: 1,
                    PAGESIZE: globleParamsSet.setResourceCenterPageSize,
                };
                $scope.status = {
                    singleGraph: false, // 是否为单图模式
                    multiImgsReady: false // 多图加载完成
                };
                $scope.data = {
                    items: [], // 图片数组
                    keywords: '', // 检索关键词
                    selectedArray: [], // 选中数据的数组
                    itemCounts: 0 // 显示的稿件数量
                };
                $scope.params = { // 列表参数
                    serviceid: 'tpg',
                    modelid: 'findFromNavigation',
                    typeid: 'zyzx',
                    nodeId: $stateParams.nodeid,
                    typeName: $stateParams.typename,
                    keyword: {
                        docId: '', // 拆分多图
                        time: '-1', // 时间范围
                        picSize: '-1', // 图片尺寸
                        width: '', // 图片宽度
                        height: '', // 图片高度
                        keywords: '', // 检索关键词
                        medianame: $state.params.medianame
                    },
                    pageNum: $scope.page.CURRPAGE,
                    pageSize: $scope.page.PAGESIZE
                };
                $scope.basicParams = initPictureDataService.getOriginData($stateParams.nodeid);
            }

            /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
            function initData() {
                listenStorage();
                requestData();
            }

            /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
            function listenStorage() {
                storageListenerService.listenResource(function() {
                    requestData();
                    storageListenerService.removeListener('resource');
                }, $scope);
            }

            /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
            function requestData() {
            // 初始化清空页面
                $scope.data.selectedArray = [];
                $scope.data.itemCounts = 0;
                $scope.status.multiImgsReady = false;
                var index = $scope.data.items.length;
                var params = angular.copy($scope.params);
                params.keyword = JSON.stringify(params.keyword);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    $scope.page.CURRPAGE = data.summary_info.CURRPAGE;
                    $scope.page.PAGECOUNT = data.summary_info.PAGECOUNT || 0;
                    if (data.content.length > 0) {
                        $scope.data.items = $scope.data.items.concat(data.content);
                        if ($scope.status.singleGraph) {
                            $scope.loadingPromise = getPicArrayById(tempItems, index).then(function(_data) {
                                $scope.status.multiImgsReady = false;
                                $scope.data.items = angular.copy(_data);
                                $timeout(function() {
                                    for (var i = 0; i < $scope.data.items.length; i++) {
                                        if (!$scope.data.items[i].lastLineHide) {
                                            $scope.data.itemCounts++;
                                        }
                                    }
                                }, 100);
                            });
                        } else {
                            $scope.loadingPromise = getPicArrayById($scope.data.items, index).then(function() {
                                $scope.status.multiImgsReady = true;
                                $timeout(function() {
                                    for (var i = 0; i < $scope.data.items.length; i++) {
                                        if (!$scope.data.items[i].lastLineHide) {
                                            $scope.data.itemCounts += $scope.data.items[i].imgurl.length;
                                        }
                                    }
                                }, 100);
                            });
                        }
                    }
                });
            }

            /**
         * [getPicArrayById description] 获取图集by ID
         * @param  {[type]} data  [description] 稿件数据
         * @param  {[type]} index [description] 稿件index
         * @return {[type]}       [description]
         */
            function getPicArrayById(data, index) {
                var deffer = $q.defer();
                var startIndex = index;
                var tempData = [];
                splitPics(data, index, function(_data) {
                    if ($scope.status.singleGraph) {
                        data.splice(startIndex, data.length - startIndex);
                        data = data.concat(_data);
                    }
                    deffer.resolve(data);
                }, tempData);
                return deffer.promise;
            }

            /**
         * [splitPics description] 拆分稿件获取图集
         * @param  {[type]}   data     [description] 稿件数据
         * @param  {[type]}   index    [description] 稿件index
         * @param  {Function} callback [description] 回调函数
         * @return {[type]}            [description]
         */
            function splitPics(data, index, callback, tempData) {
                if (data[index].PICTURE_COUNT === '1') {
                    if ($scope.status.singleGraph) {
                        tempData = tempData.concat(data[index]);
                    } else {
                        data[index].imgurl = angular.copy([].concat(data[index]));
                    }
                    index++;
                    if (index === data.length) {
                        callback(tempData);
                    } else {
                        splitPics(data, index, callback, tempData);
                    }
                    return;
                }
                var params = angular.copy($scope.params);
                params.keyword.docId = data[index].DOC_ID;
                params.keyword = JSON.stringify(params.keyword);
                params.pageNum = 1;
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(_data) {
                    if ($scope.status.singleGraph) {
                        tempData = tempData.concat(_data.content);
                    } else {
                        data[index].imgurl = angular.copy(_data.content);
                    }
                    index++;
                    if (index === data.length) {
                        callback(tempData);
                    } else {
                        splitPics(data, index, callback, tempData);
                    }
                });
            }

            /**
         * [searchWithKeyword description] 根据条件筛选稿件
         * @param  {[type]} key   [description] 筛选类型
         * @param  {[type]} value [description] 筛选内容
         * @param  {[type]} ev    [description] 键盘按键
         * @return {[type]}       [description]
         */
            $scope.searchWithKeyword = function(key, value, ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    if (key == 'time') {
                        value = $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() ? $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() + ',' + $filter('date')($scope.data.untildate, 'yyyy/MM/dd').toString() : '';
                    }
                    $scope.params.keyword[key] = value;
                    $scope.params.pageNum = $scope.page.CURRPAGE = 1;
                    $scope.data.items = [];
                    requestData();
                }
            };

            /**
         * [selectAll description] 全选
         * @return {[type]} [description]
         */
            $scope.selectAll = function() {
            // 单图或多图模式下的全选
                if ($scope.status.singleGraph) {
                // 只全选显示部分的稿件，未显示部分的稿件不选中
                    if ($scope.data.selectedArray.length == $scope.data.itemCounts) {
                        $scope.data.selectedArray = [];
                    } else {
                        var displayedItems = [];
                        for (var k = 0; k < $scope.data.items.length; k++) {
                            if (!$scope.data.items[k].lastLineHide) {
                                displayedItems.push($scope.data.items[k]);
                            }
                        }
                        $scope.data.selectedArray = [].concat(displayedItems);
                    }
                } else {
                    var selectedArray = [];
                    var lackIndexArray = []; // 缺少的项目的index数组
                    var existIndexArray = []; // 已经存在的项目的index数组
                    for (var i = 0; i < $scope.data.items.length; i++) {
                        if (!$scope.data.items[i].lastLineHide) {
                            $scope.checkAtlasIsAllSelected($scope.data.items[i], lackIndexArray, existIndexArray);
                            for (var j = 0; j < $scope.data.items[i].imgurl.length; j++) {
                                selectedArray.push($scope.data.items[i].imgurl[j]);
                            }
                        }
                    }
                    $scope.data.selectedArray = lackIndexArray.length > 0 ? selectedArray : [];
                }
            };

            /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
            $scope.selectDoc = function(item) {
            // 单图或多图模式下的单选
                if ($scope.status.singleGraph) {
                    if ($scope.data.selectedArray.indexOf(item) < 0) {
                        $scope.data.selectedArray.push(item);
                    } else {
                        $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                    }
                } else {
                // 选中图集或者单图
                    if (angular.isDefined(item.imgurl)) {
                        var lackIndexArray = []; // 缺少的项目的index数组
                        var existIndexArray = []; // 已经存在的项目的index数组
                        var selectedAll = $scope.checkAtlasIsAllSelected(item, lackIndexArray, existIndexArray);
                        // 图集的全选或取消全选
                        if (!selectedAll) {
                            for (var j = 0; j < lackIndexArray.length; j++) {
                                $scope.data.selectedArray.push(item.imgurl[lackIndexArray[j]]);
                            }
                        } else {
                            var selectedArray = angular.copy($scope.data.selectedArray);
                            for (var k = 0; k < existIndexArray.length; k++) {
                                $scope.data.selectedArray.splice(existIndexArray[k] - k, 1);
                            }
                        }
                    } else {
                        if ($scope.data.selectedArray.indexOf(item) < 0) {
                            $scope.data.selectedArray.push(item);
                        } else {
                            $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                        }
                    }
                }
            };

            /**
         * [checkAtlasIsAllSelected description] 多图模式下是否选中单个图集
         * @param {[type]} [item] [description] 当前图集
         * @param  {[type]} lack  [description] 缺少的项目的index数组
         * @param  {[type]} exist [description] 已经存在的项目的index数组
         * @return {[type]}       [description]
         */
            $scope.checkAtlasIsAllSelected = function(item, lack, exist) {
                if (angular.isUndefined(item.imgurl)) {return;}
                var lackIndexArray = angular.isDefined(lack) ? lack : [];
                var existIndexArray = angular.isDefined(exist) ? exist : [];
                var selectedAll = true; // 是否已经被全选
                var selectedIndex; // 已选中的存在的项目的index
                for (var i = 0; i < item.imgurl.length; i++) {
                    selectedIndex = $scope.data.selectedArray.indexOf(item.imgurl[i]);
                    if (selectedIndex < 0) {
                        lackIndexArray.push(i);
                        selectedAll = false;
                    } else {
                        existIndexArray.push(selectedIndex);
                    }
                }
                return selectedAll;
            };

            /**
         * [singleGraphMode description] 是否为单图模式
         * @return {[type]} [description]
         */
            $scope.singleGraphMode = function() {
                $scope.data.items = [];
                $scope.status.singleGraph = !$scope.status.singleGraph;
                $scope.params.pageNum = $scope.page.CURRPAGE = 1;
                requestData();
            };

            /**
         * [openDetail description] 打开详情页
         * @param  {[type]} item [description] 当前稿件
         * @return {[type]}      [description]
         */
            $scope.openDetail = function(item) {
                var previewPath, previewParams, previewUrl;
                if ($scope.basicParams.channelName == 'gxgk') {
                    angular.forEach($scope.data.items, function(value, index) {
                        value.METADATAID = value.DOC_ID;
                        value.DOCTYPEID = 2;
                    });
                    storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID', 'gxgkDetail');
                    previewPath = 'resourcegxgkdetail';
                    previewParams = {
                        metadataid: item.DOC_ID,
                        type: 2,
                        frompictures: true
                    };
                } else if ($scope.basicParams.channelName == 'jtcpg') {
                    angular.forEach($scope.data.items, function(value, index) {
                        value.ZB_GUID = value.DOC_ID;
                    });
                    storageListenerService.previewPageTurningStorage($scope.data.items, 'ZB_GUID', 'resourceDetail');
                    previewPath = 'resourcedetail';
                    previewParams = {
                        guid: item.DOC_ID,
                        channel: 'jtcpg',
                        frompictures: true,
                        onlyimageorcontent: 1
                    };
                } else if ($scope.basicParams.channelName == 'tpg') {
                    storageListenerService.previewPageTurningStorage($scope.data.items, 'DOC_ID', 'resourceDetail');
                    previewPath = 'resourcepicturedetail';
                    previewParams = {
                        guid: item.DOC_ID,
                        nodeid: $stateParams.nodeid
                    };
                }
                previewUrl = $state.href(previewPath, previewParams);
                $window.open(previewUrl);
            };

            /**
         * [loadMore description] 加载更多
         * @return {[type]} [description]
         */
            $scope.loadMore = function() {
                $scope.params.pageNum++;
                requestData();
            };

            /** --------- 稿件操作开始 --------- */
            /**
         * [CreationAxis description] 个人素材
         */
            $scope.CreationAxis = function() {
                var params = {
                    channelName: 'tpg',
                    nodeId: $stateParams.nodeid
                };
                // params.guid = $scope.status.singleGraph === true ? "" : trsspliceString.spliceString($scope.data.selectedArray, "DOC_ID", ",");
                params.guid = '';
                params.PICIDS = trsspliceString.spliceString($scope.data.selectedArray, 'PIC_ID', ',');
                resourceCenterService.setBigDataCreation(params).then(function(data) {
                    modalDialog.alertType('添加成功', '', 'success', false);
                    $scope.data.selectedArray = [];
                });
            };

            /**
         * [collect description] 收藏
         * @return {[type]} [description]
         */
            $scope.collect = function() {
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: $scope.basicParams.channelName == 'tpg' || $scope.basicParams.channelName == 'gxgk' ? 'collectPics' : 'collect',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'DOC_ID', ','),
                    indexName: $scope.basicParams.indexName,
                    nodeId: $stateParams.nodeid,
                    channelName: $scope.basicParams.channelName == 'tpg' || $scope.basicParams.channelName == 'gxgk' ? 'tpg' : $scope.basicParams.channelName,
                    typeName: $scope.basicParams.channelName == 'tpg' || $scope.basicParams.channelName == 'gxgk' ? 'tpg' : $scope.basicParams.typeName
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    modalDialog.alertType('收藏成功!', '', 'success', false, function() {
                        $scope.data.selectedArray = [];
                    });
                });
            };

            /**
         * [printbtn description] 打印
         * @return {[type]} [description]
         */
            $scope.printbtn = function() {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件!', '', 'warning', false, '');
                    return;
                }
                var params;
                if ($scope.basicParams.channelName == 'gxgk') {
                    angular.forEach($scope.data.selectedArray, function(value, key) {
                        requestPrintVersion(value).then(function(data) {
                            requestPrintData(value, data);
                        });
                    });
                } else if ($scope.basicParams.channelName == 'tpg') {
                    params = {
                        serviceid: 'tpg',
                        modelid: 'bmtDetail',
                        typeid: 'zyzx',
                        docId: trsspliceString.spliceString($scope.data.selectedArray, 'DOC_ID', ',')
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        trsPrintService.trsPrintHistoryPictures(data);
                    // $scope.data.selectedArray = [];
                    });
                } else if ($scope.basicParams.channelName == 'jtcpg') {
                    params = {
                        serviceid: $scope.basicParams.channelName,
                        modelid: 'detailData',
                        guid: trsspliceString.spliceString($scope.data.selectedArray, 'DOC_ID', ','),
                        typeid: 'zyzx',
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        trsPrintService.trsPrintBigData(data);
                    // $scope.data.selectedArray = [];
                    });
                }
            };

            /**
         * [requestPrintVersion description] 共享图片打印请求流程
         * @param  {[type]} item [description] 当前稿件
         * @return {[type]}      [description]
         */
            function requestPrintVersion(item) {
                var deferred = $q.defer();
                $scope.status.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), {
                    serviceid: 'mlf_metadatalog',
                    methodname: 'query',
                    MetaDataId: item.DOC_ID
                }, 'get').then(function(data) {
                    deferred.resolve(data.DATA);
                });
                return deferred.promise;
            }

            /**
         * [requestPrintData description] 共享图片打印请求详情
         * @param  {[type]} item    [description] 当前稿件
         * @param  {[type]} version [description] 当前稿件的流程
         * @return {[type]}         [description]
         */
            function requestPrintData(item, version) {
                var params = {
                    'serviceid': 'mlf_myrelease',
                    'methodname': $scope.status.methodname[item.DOCTYPEID],
                    'MetaDataId': item.DOC_ID
                };
                $scope.status.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    var result = data;
                    data.VERSION = version;
                    data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                    $scope.data.printResult.push(result);
                    if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                        trsPrintService.trsPrintShare($scope.data.printResult);
                    // $scope.data.printResult = [];
                    }
                });
            }

            /**
         * [export description] 导出
         * @return {[type]} [description]
         */
            $scope.export = function() {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择稿件!', '', 'warning', false, '');
                    return;
                }
                var params = {};
                if ($scope.basicParams.channelName == 'gxgk') {
                    params = {
                        serviceid: 'mlf_exportword',
                        methodname: 'exportWordFile',
                        MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'DOC_ID', ',')
                    };
                } else {
                    params = {
                        serviceid: 'mlf_exportword',
                        methodname: 'exportBigDataDocs',
                        CHANNELNAMES: $scope.basicParams.channelName,
                        GUIDS: trsspliceString.spliceString($scope.data.selectedArray, 'DOC_ID', ','),
                        indexName: $scope.basicParams.indexName,
                        nodeid: $stateParams.nodeid
                    };
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
                    $scope.data.selectedArray = [];
                });
            };

            /** --------- 稿件操作结束 --------- */
            /**
         * [scrollShowMore description] 滚动加载更多
         * @return {[type]} [description]
         */
            $scope.scrollShowMore = function() {
                if ($scope.page.CURRPAGE < $scope.page.PAGECOUNT){
                    $scope.loadMore();
                } else {
                    console.log('已经到了底部');
                    return;
                }

            };

            /**
         * [openPageForSearch description] 打开高级检索新页面
         * @return {[date]} [description]
         */
            $scope.openPageForSearch = function() {
                var url = $state.href('resadvancedsearch');
                window.open(url, '_blank');
            };
        }
    ]);
